import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-media-monitor',
  templateUrl: './social-media-monitor.component.html',
  styleUrls: ['./social-media-monitor.component.scss']
})
export class SocialMediaMonitorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/social-media-monitor/social-media-monitor.component.ts